import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.statusBars
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.layout.windowInsetsTopHeight
import androidx.compose.material3.LocalTextStyle
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.zIndex
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import model.ClientNavRequestEvent
import org.koin.compose.KoinApplication
import org.koin.compose.koinInject
import org.koin.core.context.stopKoin
import ui.Colors
import ui.NavigationViewModel
import ui.dialogs.HandleDialogs
import ui.snackbars.HandleSnackBars

val appMaxWidth = 500.dp

@Composable
fun App(
    clientNavRequestStateFlow: StateFlow<ClientNavRequestEvent> = MutableStateFlow(ClientNavRequestEvent.Nothing),
    locationListener: (String) -> Unit = {},
    titleListener: (String) -> Unit = {},
) {
    KoinApplication(application = {
        modules(appModules)
    }) {
        CompositionLocalProvider(
            LocalTextStyle provides LocalTextStyle.current.copy(
                fontSize = 16.sp,
            ),
        ) {
            DisposableEffect(null) {
                onDispose {
                    stopKoin()
                }
            }
            val viewModel: NavigationViewModel = koinInject()
            titleListener(viewModel.clientName)
            MaterialTheme {
                StatusBarScrim(
                    color = Color.Gray,
                    alpha = 0.35f
                )
                Box(
                    modifier = Modifier
                        .fillMaxSize()
                        .background(Colors.Default),
                    contentAlignment = Alignment.Center
                ) {
                    val showAppFullScreen by viewModel.showAppFullScreen.collectAsState()
                    Scaffold(
                        snackbarHost = {
                            HandleSnackBars(viewModel.snackbarStateStateFlow)
                        },
                        topBar = {
                            if (!showAppFullScreen) {
                                AppBar(viewModel)
                            }
                        },
                        modifier = Modifier.widthIn(
                            0.dp,
                            if (showAppFullScreen) Dp.Unspecified else appMaxWidth
                        )
                    ) { innerPadding ->
                        Box(
                            modifier = Modifier.padding(innerPadding)
                        ) {
                            AppContent(viewModel, locationListener)
                        }
                    }
                }
            }
            ClientNavigation(viewModel, clientNavRequestStateFlow, locationListener)
            HandleDialogs(viewModel)
        }
    }
}

@Composable
private fun ClientNavigation(
    viewModel: NavigationViewModel,
    clientNavRequestStateFlow: StateFlow<ClientNavRequestEvent>,
    locationListener: (String) -> Unit,
) {
    val _clientNavRequest by clientNavRequestStateFlow.collectAsState()
    val clientNavRequest = _clientNavRequest
    if (!clientNavRequest.isRead) {
        when (clientNavRequest) {
            ClientNavRequestEvent.Nothing -> Unit
            is ClientNavRequestEvent.Back -> viewModel.popBackStack()
            is ClientNavRequestEvent.HashStateChangeEvent -> viewModel.hashStateChangeEvent(clientNavRequest.newHash, locationListener)
        }
    }
}

@Composable
fun StatusBarScrim(
    color: Color,
    alpha: Float
) {
    val scrimColor = color.copy(alpha = alpha.coerceIn(0f, 1f))
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .zIndex(1f)
    ) {
        Box(
            modifier = Modifier
                .align(Alignment.TopCenter)
                .windowInsetsTopHeight(WindowInsets.statusBars)
                .fillMaxWidth()
                .background(scrimColor)
        )
    }
}